module.exports = __webpack_public_path__ + "media/images/application/template/maps/technical-services-engineer-3cc5435bc64da4642ff929d622be7dd3.svg";